<div class="" *ngIf="pageTitle != 'Faculty'">
<section class="aarni-font relative w-full object-cover mt-[80px]" *ngIf="pageTitle != 'Advisory Board'">
        <picture>
            <source media="(min-width:1024px)" [srcset]="getImageSrc()">
            <source media="(min-width: 768px)" [srcset]="getImgForMediumScreen()">
            <img [src]="getImageForPhoneView()" alt="" class="h-auto w-full">
        </picture>
    </section>
    <section class="aarni-font w-full shadow border-b  mt-[80px] py-[50px]" *ngIf="pageTitle === 'Advisory Board'">
        <div class="container mx-auto px-4 md:px-32">
            <h1 class=" text-center md:text-start font-bold text-[32px]">
                {{ pageTitle }}
            </h1>
        </div>
    </section>

    <div class="flex items-start justify-center p-4 bg-gray-50 aarni-font">
        <div class="flex flex-col lg:flex-row gap-4 p-4 w-full max-w-7xl">
            <aside
                class="w-full lg:w-1/4 space-y-4 max-h-screen overflow-y-auto overflow-x-hidden pr-2">
                <div class="border-t-8 border-orange-500">
                    <div class="bg-white shadow border border-gray-300">
                        <h2 class="text-lg font-bold p-4">Get To Know Arni</h2>
                        <div class="">
                            <a [href]="'about/about-us'"
                               [ngClass]="{'text-white bg-blue-600' : pageTitle === 'About Us', 'text-blue-600 bg-white' : pageTitle !== 'About Us'}"
                               class="flex items-center space-x-2 p-3 w-full text-blue-600 border-b border-gray-30 cursor-pointer0 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                                <i class="fa fa-arrow-right"></i>
                                <span>Overview & Identity</span>
                            </a>
                            <a [href]="'about/core-values'"
                               [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Core Values', 'text-blue-600 bg-white' : pageTitle !== 'Core Values'}"
                               class="flex items-center space-x-2 p-3 w-full text-blue-600 border-b border-gray-300 cursor-pointer hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                                <i class="fa fa-arrow-right"></i>
                                <span>Core Values</span>
                            </a>
                            <a [href]="'about/mission-and-vision'"
                               [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Mission And Vision', 'text-blue-600 bg-white' : pageTitle !== 'Mission And Vision'}"
                               class="flex items-center space-x-2 p-3 w-full text-blue-600 border-b border-gray-300 cursor-pointer hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                                <i class="fa fa-arrow-right"></i>
                                <span>Mission and Vision</span>
                            </a>

                            <a [href]="'about/leadership/chancellor'"
                               [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Leadership', 'text-blue-600 bg-white' : pageTitle !== 'Leadership'}"
                               class="flex items-center space-x-2 p-3 w-full text-blue-600 border-b border-gray-300 cursor-pointer hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                                <i class="fa fa-arrow-right"></i>
                                <span>Leadership</span>
                            </a>
                            <a [href]="'about/faculty'"
                               [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Faculty', 'text-blue-600 bg-white' : pageTitle !== 'Faculty'}"
                               class="flex items-center space-x-2 p-3 w-full text-blue-600 border-b border-gray-300 cursor-pointer hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                                <i class="fa fa-arrow-right"></i>
                                <span>Faculty</span>
                            </a>
                            <a [href]="'about/approvals'"
                               [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Approvals', 'text-blue-600 bg-white' : pageTitle !== 'Approvals'}"
                               class="flex items-center border-b space-x-2 p-3 w-full text-blue-600 cursor-pointer hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                                <i class="fa fa-arrow-right"></i>
                                <span>Approvals</span>
                            </a>
                            <a [href]="'about/ai-integrated-program'"
                               [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Ai Integrated Program', 'text-blue-600 bg-white' : pageTitle !== 'Ai Integrated Program'}"
                               class="flex items-center space-x-2 p-3 w-full text-blue-600 cursor-pointer hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                                <i class="fa fa-arrow-right"></i>
                                <span>AI Integrated Program</span>
                            </a>
                        </div>
                    </div>
                </div>
                <h2 class="text-lg font-semibold mb-4">Quick Links</h2>
                <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                    <div class="space-y-2">
                        <a href="/about/faculty" class="flex items-center  space-x-3 p-2 rounded-lg">
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                            <span class="text-gray-700 font-medium pl-4 text-xl">Faculty</span>
                        </a>
                    </div>
                </div>

                <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                    <div class="space-y-2">
                        <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                            <span class="text-gray-700 font-medium text-xl pl-4">Testimonials</span>
                        </a>
                    </div>
                </div>

                <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                    <div class="space-y-2">
                        <a href="/about/leadership/chancellor" class="flex items-center space-x-3 p-2 rounded-lg ">
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-phone text-2xl"></i>
            </span>
                            <span class="text-gray-700 font-medium pl-4 text-xl">Leadership</span>
                        </a>
                    </div>
                </div>

                <div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                    <div class="space-y-2">
                        <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-camera text-2xl"></i>
            </span>
                            <span class="text-gray-700 font-medium pl-4 text-xl">Contact Us</span>
                        </a>
                    </div>
                </div>
            </aside>

            <section
                class="flex-1 shadow-lg p-6 border-2 border-gray-200 rounded-lg aarni-font h-fit text-justify">
                <h1 class="text-[24px] font-semibold my-6 px-6">{{ pageTitle }}</h1>
                <div *ngIf="pageTitle === 'About Us'">
                    <img src="assets/img/iqac/internal-banner-iqac-desktop.webp" alt="">
                    <p class="text-gray-500 text-justify my-3">
                        ARNI University is one of the leading institutions in India for higher education, and it stands
                        out for its unique blend of academic and technical excellence for its students. The University
                        was established in 2009 and recognized by the UGC, India. With diverse programs emphasizing
                        versatility, experiential learning, and interdisciplinary approaches, we empower modern learners
                        to transform their dreams into reality while nurturing students’ passions and guiding them
                        toward achieving success.
                    </p>
                    <p class="text-gray-500 text-justify my-3">
                        The State Government of Himachal Pradesh founded ARNI University as a State Private University.
                        It was incorporated by the ARNI University (Establishment and Regulation) Act No. 23 of 2009,
                        which was later revised by Act No. 12 of 2011, and it was officially announced as a university
                        by No. of notification: EDN
                    </p>
                    <p class="text-gray-500 text-justify my-3">
                        November 3, 2009, A‐Ka (1)‐23/2007. The university is situated in the Indora Tehsil of District
                        Kangra, Himachal Pradesh, close to the village of Kathgarh. It is under the territorial control
                        of the district.
                    </p>
                    <p class="text-gray-500 text-justify my-3">
                        The university's campus is situated in a picturesque setting by a running river. It is only 26
                        kilometers from Pathankot and 6 km from Indora Tehsil, and it is conveniently located near the
                        national highway from Jalandhar-Pathankot. Situated in the foothills of the Dhauladhar Mountain
                        Ranges and overlooking the Beas River, the university boasts one of the most picturesque, green,
                        and pollution-free campuses.
                    </p>
                    <p class="text-gray-500 text-justify my-3">
                        The university was founded to satisfy the goals of the residents of Kangra District in Himachal
                        Pradesh in light of the country's need for skilled labor, as envisioned by the Knowledge
                        Commission. The largest district in Himachal Pradesh is Kangra, and as of right now, there are
                        no higher education options within 200 kilometers. Therefore, the university will be able to
                        train the increasing number of students who would otherwise have to go to Amritsar, Chandigarh,
                        Jalandhar, and even Gwalior in M P.
                    </p>
                    <p class="text-gray-500 text-justify my-3">
                        Its motto, "Bringing Ambition to Life," is something that the founder, faculty, and staff are
                        committed to. The values of ambition, inclusivity, integrity, equity, respect, and
                        sustainability serve as the foundation for this credo in all that we do.
                    </p>
                </div>
                <div *ngIf="pageTitle === 'Core Values'">
                    <p class="text-gray-500 text-justify my-3">By outlining the fundamentals of what an education
                        entails, our core values direct and influence
                        the success of our students. Students' pride and sense of belonging to the university are
                        increased by this acknowledged set of principles, which can also turn their experience into
                        enduring loyalty. </p>
                    <p class="text-gray-500 text-justify my-3">Through a common sense of purpose and identity, our
                        values also foster the growth and engagement of our professors and staff. They create an
                        atmosphere of creativity, inclusivity, and respect while fostering a culture that values and
                        honors the abilities and dedication of our people.</p>
                    <div *ngFor="let section of coreValues; let i = index">
                        <button
                            class="w-full border text-start items-center p-2"
                            (click)="toggleAccordion(i)"
                        >
                            <i class="text-lg"
                               [ngClass]="activeIndex === i ? 'fas fa-minus text-blue-500' : 'fas fa-plus text-blue-500'"

                            >
                            </i>
                            <span class="ml-2 text-start font-bold text-lg md:text-xl">{{
                                    section.heading
                                }}
                        </span>
                            <div
                                *ngIf="activeIndex === i"
                                @fadeInOut
                                class="p-2 text-gray-700  rounded text-start border sm:text-sm"
                                [innerHTML]="section.content"
                            >
                            </div>
                        </button>
                    </div>
                </div>
                <div *ngIf="pageTitle === 'Mission And Vision'">
                    <p class="px-6"><span class="font-semibold text-lg">Our Vision-</span> We have a clear vision to
                        bring positive change and transformative impact on society
                        through incredible achievements in learning, continual innovation in education, research,
                        entrepreneurship, and creativity. We are empowering our students to contribute to the economic
                        development and stability of our nation.
                    </p>
                    <ul class="list-disc px-6">
                        <li><span class="font-semibold">Commitment to Academic Excellence -</span> To establish a school
                            with strong professionalism, scientific learning, and high-quality instruction.
                        </li>
                        <li><span class="font-semibold">Bridging Education with Employability -</span> An organization
                            that smoothly integrates education and employment for the benefit of students, employees,
                            and society as a whole.
                        </li>
                        <li><span class="font-semibold">Global Standards in a Himalayan Setting -</span> Through
                            multidisciplinary study, international variety, and the adoption of best practices, this
                            institution will foster both individual greatness and group endeavors in the tranquil
                            Himalayan setting.
                        </li>
                    </ul>
                    <p class="px-6 my-4"><span class="font-semibold text-lg">Our Mission-</span> Being one of the
                        leading educational institutes, we are on a mission to create a better place for modern learners
                        by providing an education that blends with skill-building, innovation, and real-world
                        experiences. We are working to nurture individuals who are not just academically proficient but
                        socially responsible.
                    </p>
                    <ul class="list-disc px-6">
                        <li><span class="font-semibold">Fostering Innovation and Creative Excellence -</span> To
                            establish a school
                            with strong professionalism, scientific learning, and high-quality instruction.
                        </li>
                        <li><span class="font-semibold">Career-Driven Programs with a Leadership Focus -</span> Our
                            Programs are designed to meet the growing demand of the modern workforce. Create leadership
                            that is assertive, efficient, and effective.
                        </li>
                        <li><span class="font-semibold">Empowering Responsible and Impactful Citizens -</span> Shaping
                            not only capable professionals but also responsible citizens who contribute to cultural and
                            economic development. We are hoping for positive change in society that is possible with
                            capable leaders.
                        </li>
                    </ul>
                </div>
                <div class="px-6" *ngIf="pageTitle === 'Ai Integrated Program'">
                    <div>
                        <p class="text-gray-700 text-justify my-3">
                            As we know, AI is the future! Artificial Intelligence is not just a trend—it’s transforming
                            the way we live, work, and solve problems. At ARNI University, our AI Integrated Program is
                            designed to equip students with practical skills, interdisciplinary knowledge, and an
                            innovation-first mindset to thrive in this evolving landscape.
                        </p>

                        <h2 class="font-semibold text-gray-700">Industry-Ready Curriculum</h2>
                        <p class="text-gray-700 text-justify my-3">
                            Our AI modules are continuously updated with inputs from top recruiters, data scientists,
                            and technology leaders. Students work on real-world projects and case studies, preparing
                            them for roles like AI Developer, ML Engineer, and Data Analyst.
                        </p>

                        <h2 class="font-semibold text-gray-700">Utilize the Power of AI</h2>
                        <p class="text-gray-700 text-justify my-3">
                            Through our courses, we are focused on foundational concepts of AI and how it impacts the
                            real-world. We have integrated AI into traditional disciplines like business, engineering,
                            and healthcare, promoting interdisciplinary learning and fostering innovation-driven
                            research.
                        </p>

                        <h2 class="font-semibold text-gray-700">Learning Agility</h2>
                        <p class="text-gray-700 text-justify my-3">
                            Through the numerous learning and teaching methods, we instill adaptability, curiosity, and
                            rapid learning by encouraging hands-on experimentation, hackathons, and research-driven
                            problem-solving, helping learners stay ahead of the curve.
                        </p>

                        <h2 class="font-semibold text-gray-700">Customizable Learnings</h2>
                        <p class="text-gray-700 text-justify my-3">
                            Through the AI advancements, we offer customizable learning, one-on-one mentoring,
                            collaborative group discussions, and interactive sessions tailored to individual learning
                            speeds and styles.
                        </p>
                        <p class="text-gray-700 text-justify">
                            What’s More? Students gain access to custom-built AI tools tailored to enhance placement
                            preparation, problem-solving, and project development, ensuring a smoother transition from
                            academia to industry.
                        </p>
                        <h2 class="font-semibold text-gray-700 my-2">Specialized Courses Under the Program</h2>
                        <p class="text-gray-700 text-justify my-3">
                            Diploma in Artificial Intelligence & Machine Learning (1 Year)
                        </p>
                        <p class="text-gray-700 text-justify">
                            This intensive program dives into:
                        </p>
                        <ul class="list-disc px-8 text-gray-700">
                            <li class="my-2">Core AI & ML algorithms</li>
                            <li class="my-2">Neural networks & Deep learning</li>
                            <li class="my-2">Natural Language Processing (NLP)</li>
                            <li class="my-2">AI in Robotics & Automation</li>
                        </ul>
                        <p class="text-gray-700 text-justify my-2">Includes live projects, mentorship by AI
                            professionals, and internship opportunities with leading tech firms.
                        </p>
                    </div>
                </div>
                <section class=" hidden lg:block">
                    <div class="px-6" *ngIf="pageTitle === 'Approvals'">
                        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-6 p-8 w-full">
                            <div
                                *ngFor="let approval of approvals"
                                class="border overflow-hidden hover:shadow-md transition-all duration-300 cursor-pointer"
                                (click)="openPdfModal(approval.pdf)"
                            >
                                <div class="block">
                                    <img
                                        *ngIf="approval.image"
                                        [src]="approval.image"
                                        [alt]="approval.title"
                                        class="w-full h-full object-cover"
                                    />

                                    <div class="flex flex-col items-center p-4 text-center">
                                        <h3 class="text-base font-semibold text-[#012E26] hover:text-[#00BFA5]">
                                            {{ approval.title }}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="selectedPdf"
                         class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 px-4">
                        <div class="relative w-full max-w-5xl mx-auto">
                            <div class="flex justify-end mb-2">
                                <button
                                    (click)="closePdfModal()"
                                    class="text-white text-2xl font-bold border border-white rounded-md w-10 h-10 flex items-center justify-center hover:bg-white hover:text-black transition"
                                >
                                    &times;
                                </button>
                            </div>

                            <div class="relative w-full pt-[56.25%] rounded-lg shadow-lg overflow-hidden">
                                <iframe
                                    [src]="selectedPdf"
                                    class="absolute top-0 left-0 w-full h-full"
                                    frameborder="0"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="approvals-sm" class="block lg:hidden" *ngIf="pageTitle === 'Approvals'">
                    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 p-8 w-full">
                        <div
                            *ngFor="let approval of approvals"
                            class="border overflow-hidden hover:shadow-md transition-all duration-300 cursor-pointer w-full"
                            (click)="openInNewTab(approval.pdf)"
                        >
                            <div class="block">
                                <img
                                    *ngIf="approval.image"
                                    [src]="approval.image"
                                    [alt]="approval.title"
                                    class="w-full h-full object-contain"
                                />

                                <div class="flex flex-col items-center p-4 text-center">
                                    <h3 class="text-sm font-semibold text-[#012E26] hover:text-[#00BFA5]">
                                        {{ approval.title }}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    </div>
</div>

<div *ngIf="pageTitle === 'Faculty'">
    <div class="aarni-font relative block">
        <picture>
            <source media="(min-width:1024px)" srcset="/assets/img/about/faculty-about-us.webp">
            <source media="(min-width:768px)" srcset="/assets/img/about/mobile-banner/faculty-about-us-2.webp">
            <img
                src="/assets/img/about/mobile-banner/faculty-about-us.webp"
                alt="Faculty Banner"
                class="w-full h-auto"
            >
        </picture>
        <div class="max-w-7xl mx-auto px-6 md:px-10">
            <h1 class="uppercase text-center absolute bottom-52 md:text-start font-bold text-white text-[32px] shadow">
                {{ pageTitle }}
            </h1>
        </div>
    </div>

    <div class="border">
        <div class="flex flex-col lg:flex-row gap-4  w-full justify-between max-w-7xl mx-auto px-4">
            <div class="w-full  flex-wrap max-w-7xl mx-auto  py-6 flex">
                <ul class=" w-[90%] mx-auto  lg:w-[70%]  flex flex-wrap">
                    <li
                        *ngFor="let tab of facultyTabs; let i = index"
                        (click)="onTabChange(tab.key)"
                        class="px-4 cursor-pointer my-2 md:my-0  py-2 text-sm font-medium transition-all "
                        [ngClass]="{
                            'border-l-2' : i !== 0,
                            ' text-orange-600 font-semibold': selectedTab === tab.key,
                            ' text-gray-500 hover:text-orange-500': selectedTab !== tab.key}">
                        {{ tab.label }}
                    </li>
                </ul>

                <div class=" w-[90%] mx-auto lg:me-0 lg:w-[30%] relative  text-end ">
                    <form [formGroup]="searchForm">
                        <input formControlName="search_key"
                               (keyup)="onSearch()" type="text"
                               class="border outline-none bg-gray-50  rounded p-2 w-full" placeholder="Search by name">
                    </form>

                    <i class="fa-solid fa-magnifying-glass absolute top-3 right-3 text-gray-400"></i>
                </div>
            </div>
        </div>

    </div>
    <div class="bg-blue-100 pt-6 pb-20" *ngIf="filteredFacultyList.length > 0 ; else nodata">
        <div class="max-w-7xl p-6  mx-auto">
            <h2 class="text-3xl font-bold text-orange-500 underline  border-b">
                <ng-container *ngFor="let tab of facultyTabs">
                    <span *ngIf="tab.key === selectedTab">{{ tab.label }}</span>
                </ng-container>
            </h2>
        </div>
        <div class="grid max-w-7xl mx-auto grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6  px-4">
            <div
                *ngFor="let member of filteredFacultyList;"
                class="bg-white shadow-md rounded-xl p-4 text-center hover:shadow-md hover:shadow-orange-200 transition group duration-200"
            >
                <img
                    [src]="member.image"
                    alt="{{ member.name }}"
                    class="w-24 h-24 mx-auto mb-4 rounded-full object-cover border-4 border-gray-100"
                />
                <h3 class="text-lg font-semibold text-gray-800 group-hover:text-sky-600">{{ member.name }}</h3>
                <p class="text-sm text-gray-500 mt-1"><i class="fa fa-user me-2"></i>{{ member.designation }}</p>
                <p class="text-sm text-gray-500 mt-1 font-semibold" *ngIf="member && member?.incharge">({{ member.incharge }})</p>
            </div>
        </div>
    </div>
</div>

<ng-template #nodata>
    <div class="max-w-7xl  text-center p-16 lg:p-52 mx-auto">
        <div class="text-red-600 font-semibold">
            Hmm... couldn’t find anyone matching that in this tab!
            <br/>
            Try it on a different tab or category✨
        </div>

    </div>
</ng-template>
